export default __webpack_public_path__ + "static/media/closet5-after1-1920w.b7b7d39b.avif";